import { useNavigate } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
// import Dashboard from "./Pages/Dashboard/Dashboard";
import Router from "./Router/Router";
import "./Api/zincoApi";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Button, Snackbar } from "@mui/material";
import { closeSnackbar, openSnackbar } from "./features/snackbar";
import { callSettings } from "./features/setting";
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryClient, QueryClientProvider, useMutation } from "react-query";
import { LogoutFun } from "./globalFunctions";
import ZincoModal from "./Components/Component/ZincoModal";
import { Images } from "./Assets/AssetsLog";
import { callUserRoll, calluserTypeList } from "./features/userRoleSetting";
import { closeSuccessModal, openSuccessModal } from "./features/userinvite";
import { UserData } from "./globalVariable";
import { useSearchParams } from "react-router-dom";
import { invitedUser } from "./Api/UserCredentials/UserCredentialsApi";
import ZincoWarning from "./Components/AppComponent/ZincoWarning";
import ExpireWarningModal from "./Components/ExpireWarningModal/ExpireWarningModal";
// import { Button } from "@mui/base";


// let userData = JSON.parse(localStorage.getItem("UserCredentials"))
let isActive = JSON.parse(localStorage.getItem("isUserActivate"))
!isActive && localStorage.setItem("isUserActivate", JSON.stringify({isUserExpired: true, date: ""}))

function App() {
  // const queryClient = new QueryClient()  
  const navigate = useNavigate();
  const settingData = useSelector((state) => state.setting.settingDetails);
  // const isExpiredReducer = useSelector(state => state.expireState.userDetails)  
  const snackData = useSelector((state) => state.snackbar.snackBarRedux);
  const inviteUserData = useSelector((state) => state.userinvite.userInviteRedux);
  const dispatch = useDispatch();
  const user = localStorage.getItem("UserCredentials");
  const [searchParams] = useSearchParams();
  const paramValue = searchParams.get("invitation_id");

  // const [isExpired, setIsExpired] = useState(settingData.isExpired);
  // const handleCloseExpire = function () {
  //   setIsExpired(!isActive.isUserExpired);
  // };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(closeSnackbar({}));
    console.log(snackData);
  };

  const handleCloseInviteuser = (e, value) => {
    dispatch(closeSuccessModal({}));

  }

  const mutateInvite = useMutation({
    mutationFn: (newTodo) => {
      return invitedUser({ ...newTodo });
    },
    onSuccess: res => {
      if (res.StatusCode === 6000) {
        dispatch(openSuccessModal({}))
        UserData && navigate('/')
      } else{
        dispatch(
          openSnackbar({
            open: true,
            message: res.message,
            severity: "warning",
          })
        );
      }
    }
  })

  // useEffect(() => {
    // setIsExpired(isExpiredReducer.isUserExpired)
    // setIsExpired(isActive.isUserExpired)
  // }, [isExpiredReducer.isUserExpired])
  
  useEffect(() => {
    paramValue && mutateInvite.mutate({invitation_id: paramValue})
  }, [paramValue])
  

  useEffect(() => {
    // Only call when UserCredentials is on the localStorage
    UserData && dispatch(callSettings());
    // dispatch(calluserTypeList());
    // dispatch(callUserRoll());
    // AmountFormater()
  }, [])

  return (
    <>
      {/* <Outlet /> */}
      {/* <Dashboard /> */}
      {/* <QueryClientProvider client={queryClient}> */}
        <div className="App" style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
          <div style={{ flexGrow: "1" }}>
            {user && <Navbar />}
          </div>
            <Router />
          {snackData && (
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              open={snackData.open}
              autoHideDuration={6000}
              onClose={handleClose}
            >
              <Alert
                onClose={handleClose}
                severity={snackData.severity}
                sx={{ minWidth: "300px" }}
              >
                {snackData.message}
              </Alert>
            </Snackbar>
          )}
        </div>

        <ZincoModal open={inviteUserData.open} handleClose={handleCloseInviteuser}>
          <div className="px-[48px] py-[41px]">
            {/* <img src={Images.ExpireDateImage} alt="" className="mb-4"/> */}
            <iframe style={{width: "272px"}} title="loty" src="https://lottie.host/embed/de98b8ab-fcfe-4d43-a423-92e51a058a79/aJqsiphWLE.json"></iframe>
            <p className="text-[#5346BD] texxt-[16px] font-[400] text-center">
              You invited Successfully
            </p>
            <p className="text-center mb-6"></p>
            <div className="flex justify-center">
              <Button
                onClick={handleCloseInviteuser}
                sx={{
                  background: "#5346BD",
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: "400",
                  textTransform: "none",
                }}
                variant="contained"
              >
                Done
              </Button>
            </div>
          </div>
        </ZincoModal>
        <ExpireWarningModal />
        {/* <ZincoWarning handleClose={() => false} /> */}
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      {/* </QueryClientProvider> */}
    </>
  );
}

export default App;
